import { apiClient } from './api/apiClient';
import {
  TimeEntry,
  CheckInRequest,
  CheckOutRequest,
  TimeEntryStatusResponse,
  SiteAttendanceResponse
} from '../types/timeEntry.types';

const BASE_URL = '/timeentries';

export const timeEntryService = {
  /**
   * Check-in - Registra l'entrata del dipendente
   */
  checkIn: async (data: CheckInRequest): Promise<TimeEntry> => {
    return await apiClient.post<TimeEntry>(`${BASE_URL}/check-in`, data);
  },

  /**
   * Check-out - Registra l'uscita del dipendente
   */
  checkOut: async (data: CheckOutRequest): Promise<TimeEntry> => {
    return await apiClient.post<TimeEntry>(`${BASE_URL}/check-out`, data);
  },

  /**
   * Ottieni lo stato corrente del dipendente
   */
  getStatus: async (): Promise<TimeEntryStatusResponse> => {
    return await apiClient.get<TimeEntryStatusResponse>(`${BASE_URL}/status`);
  },

  /**
   * Ottieni la cronologia delle timbrature
   */
  getHistory: async (startDate?: string, endDate?: string): Promise<TimeEntry[]> => {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);

    const queryString = params.toString();
    return await apiClient.get<TimeEntry[]>(`${BASE_URL}/history${queryString ? '?' + queryString : ''}`);
  },

  /**
   * Ottieni le presenze per una sede (solo manager/owner)
   */
  getSiteAttendance: async (siteId: number, date?: string): Promise<SiteAttendanceResponse> => {
    const params = new URLSearchParams();
    if (date) params.append('date', date);

    const queryString = params.toString();
    return await apiClient.get<SiteAttendanceResponse>(
      `${BASE_URL}/site/${siteId}/attendance${queryString ? '?' + queryString : ''}`
    );
  },
};
